var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-pivottable-ui',{attrs:{"data":_vm.dataList,"rows":['HID'],"row-total":true,"col-total":true},scopedSlots:_vm._u([{key:"colGroup",fn:function(){return [_c('colGroup',{attrs:{"width":_vm.colGroupFirstWidth}}),_c('colGroup')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }